/**
 * 设备管理Device Controller 医药机模块接口列表
 */

import axios from '@/api/http'; // 导入http中创建的axios实例
import base from '@/api/base'; // 导入接口域名列表
const medicine = {
  //POST /device/attribute 修改设备设备基础属性
  setdeviceattribute(deviceAttribute) {
    return axios.post(`${base.baseURL}device/attribute`, deviceAttribute);
  },
  //GET/device/attribute/{deviceId}查询设备属性
  getdeviceattribute(deviceId) {
    return axios.get(`${base.baseURL}device/attribute/${deviceId}`);
  },
  //GET/device/device/{id}查询设备
  device(id) {
    return axios.get(`${base.baseURL}device/device/${id}`);
  },
  //GET /device/deviceNotice/{id} 对已发布设备的公告进行撤销
  deviceNotice(id){
    return axios.get(`${base.baseURL}device/deviceNotice/${id}`)
  },
  //POST /device/page 查询所有设备（可以模糊查询）
  pageDevice(params) {
    return axios.post(`${base.baseURL}device/page`, params);
  },
  //POST /device/pageforable 查询所有设备（可用的）
  pageforable(params) {
    return axios.post(`${base.baseURL}device/pageforable`, params);
  },
  //GET /device/publishAdvert/{advertId} 查询已发布广告的设备信息
  publishAdvert(advertId) {
    return axios.get(`${base.baseURL}device/publishAdvert/${advertId}`)
  },
  //GET /device/publishNotice/{NoticeId} 查询已发布公告的设备信息
  publishNotice(NoticeId) {
    return axios.get(`${base.baseURL}device/publishNotice/${NoticeId}`)
  },
  //DELETE/device/remove/{id}删除设备（根据id）
  removedevice(id) {
    return axios.delete(`${base.baseURL}device/remove/${id}`);
  },
  //POST/device/save添加/修改设备
  savedevice(device) {
    return axios.post(`${base.baseURL}device/save`,device);
  },
  //POST /device/status 启动或停用设备
  statusdevice(deviceGridStatusRequest) {
    return axios.post(`${base.baseURL}device/status`,deviceGridStatusRequest);
  },

}
export default medicine;



// WEBPACK FOOTER //
// ./src/network/medicine.js